export default "__VITE_ASSET__CURnQfev__"